import { Chips, UIText2 } from '@cian/ui-kit';
import { roomsOptions } from '../../containers/RoomsCheckbox/config';
import { ERoom } from '../../types/filter';
import * as filterStyles from '../Filters/Filters.css';

interface IRoomsCheckboxProps {
  rooms: ERoom[];
  onChange: (rooms: ERoom[]) => void;
}

export function RoomsCheckbox({ rooms, onChange }: IRoomsCheckboxProps) {
  return (
    <>
      <UIText2>Количество комнат</UIText2>
      <div className={filterStyles['input__wrapper']}>
        <Chips selectType="multiple" options={roomsOptions} value={rooms} onChange={onChange} size="S" />
      </div>
    </>
  );
}
